<template>
  <div class="leftSection">
    <div
      class="header-title wrapper-content__main font-size__large font-weight__bold"
    >
      {{ pageTitle }}
    </div>

    <div class="tagFilter">
      <VuePerfectScrollbar class="scroll-area-filter" :settings="settings">
        <span
          v-for="stateOption in stateOptions"
          :key="stateOption.id"
          :class="[
            isActive(stateOption) ? 'active' : '',
            'status-item',
            getColorClass(stateOption)
          ]"
          @click="doFilter(stateOption)"
        >
          <i :class="[getStateIcon(stateOption), 'icon-status']"></i>
          <span>{{ stateOption.name }}</span>
        </span>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import constants from "../../../constants";

export default {
  name: "hc-dieuxe-state-header",
  props: ["state", "pageTitle", "stateOptions"],
  components: {
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
  },
  data() {
    return {
      settings: { maxScrollbarLength: 750 }
    };
  },
  methods: {
    isActive(stateOption) {
      return stateOption.id === this.state;
    },

    doFilter(stateOption) {
      if (this.state !== stateOption.id) {
        this.$emit("doFilter", { state: stateOption.id });
      }
    },

    getStateIcon(stateOption) {
      switch (stateOption.id) {
        case constants.HC_STATE.STATE_CODE.DIEU_XE.DA_DANG_KY:
          return "fa fa-check-circle";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.HUY:
          return "fa fa-times-circle";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.CHO_PHE_DUYET:
          return "fa fa-clock";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.DA_PHE_DUYET:
          return "fa fa-check-circle";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.TU_CHOI:
          return "fa fa-ban";
        default:
          return "";
      }
    },

    getColorClass(stateOption) {
      if (!this.isActive(stateOption)) return "";
      switch (stateOption.id) {
        case constants.HC_STATE.STATE_CODE.DIEU_XE.DA_DANG_KY:
          // return "color__blue";
          return "info";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.HUY:
          return "danger";
          // return "color__red";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.CHO_PHE_DUYET:
          // return "color__blue";
          return "info";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.DA_PHE_DUYET:
          // return "color__green";
          return "success";
        case constants.HC_STATE.STATE_CODE.DIEU_XE.TU_CHOI:
          // return "color__red";
          return "danger";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.leftSection {
  z-index: 10;
}

.scroll-area-filter {
  max-width: 100%;
  height: 100%;
  position: relative;
  margin: auto;
  display: flex;
}

#new_main header .tagFilter .status-item.active.danger {
  /* color: var(--color-red); */
  color: white;
}

#new_main header .tagFilter .status-item.active.info {
  /* color: var(--color-blue); */
  color: white;
}

#new_main header .tagFilter .status-item.active.success {
  /* color: var(--color-green); */
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-state-header.vue